<template>
    
    <SubHeader title="Liste des Parametre" :breads="[{name:'Parametre'}]" />

</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"

export default {
    name: "AdminConfigParametre",
    components:{
        SubHeader
    },
}
</script>
